import React, { useState, useEffect } from "react";
import { format } from "date-fns";

import Dialog, { DialogContent, DialogActions } from "components/common/Dialog";
import CustomButton from "components/common/Button";
import DaySummaryCard from "components/CheckInCheckOut/DaySummaryCard/DaySummaryCard";
import { DaySummary } from "components/CheckInCheckOut/types";

import successIcon from "assets/images/check_circle.svg";

import "components/CheckInCheckOut/ClockOutSuccessModal/ClockOutSuccessModal.scss";

interface ClockOutSuccessModalProps {
  open: boolean;
  onClose: () => void;
  onViewTimesheet: () => void;
  daySummary: DaySummary;
}

function ClockOutSuccessModal({ open, onClose, onViewTimesheet, daySummary }: ClockOutSuccessModalProps) {
  const [cachedSummary, setCachedSummary] = useState<DaySummary>(daySummary);
  const formattedDate = format(new Date(), "MMM d, yyyy");

  // Cache the summary when modal opens to preserve the data from before clock-out
  useEffect(() => {
    if (open && daySummary) {
      setCachedSummary(daySummary);
    }
  }, [open, daySummary]);

  const dialogContent = (
    <DialogContent>
      <div className="text-center mb-1 top-container">
        <img src={successIcon} alt="Success" className="success-icon mb-1" />
        <p className="heading-h1-semibold color-text-headings-primary">Clock-out successful!</p>
      </div>

      <DaySummaryCard daySummary={cachedSummary} title={formattedDate} />
    </DialogContent>
  );

  const dialogActions = (
    <DialogActions
      action1={
        <CustomButton size="large" label="View Timesheet" onClick={onViewTimesheet} variant="text" color="primary" />
      }
      action2={<CustomButton size="large" label="Done" onClick={onClose} variant="contained" color="primary" />}
    />
  );

  return <Dialog open={open} onClose={onClose} size="xs" content={dialogContent} actions={dialogActions} />;
}

export default ClockOutSuccessModal;
